import { HARDCODED_SUPPLIERS } from 'components/CarHire/CarHireHardcodedLists'
import Image from 'components/Common/Image'
import LayoutContainer from 'components/Common/LayoutContainer'
import Sheet from 'components/utils/Sheet'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const SupplierLogoWrapper = styled.div`
  padding: ${rem(8)} ${rem(16)};
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  display: flex;
  align-items: center;
  justify-content: center;
`

const SuppliersLogoCarousel = styled(CardCarousel)`
  margin-top: ${rem(24)};
`

function CarsCarHireSuppliers() {
  const intl = useIntl()
  return (
    <Sheet padding="40 0" tabletPadding="64 0">
      <LayoutContainer>
        <Heading variant="heading3">
          {intl.formatMessage(
            {
              id: 'lD6muIoUceWI-1iaLg_T',
              defaultMessage: 'Featured <italic>suppliers</italic>',
              description: 'Section heading for featured suppliers section in the car hire section',
            },
            {
              italic: (chunks: React.ReactNode) => <i key="italic">{chunks}</i>,
            },
          )}
        </Heading>
        <SuppliersLogoCarousel pageSize={8} gap={12}>
          {HARDCODED_SUPPLIERS.map((supplier) => (
            <SupplierLogoWrapper key={supplier.name}>
              <Image width={80} image={supplier.image} alt={supplier.name} />
            </SupplierLogoWrapper>
          ))}
        </SuppliersLogoCarousel>
      </LayoutContainer>
    </Sheet>
  )
}

export default CarsCarHireSuppliers
